<template>
    <div>
        <div class="ibox animated fadeInRightBig">
            <div class="ibox-title">
                <h3>Novo Usuário <i class="fa fa-user-circle" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
            </div>
            <form id="form">
                <div class="ibox-content">
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label for="name"><span class="required">*</span> Nome</label>
                            <input type="text" class="form-control" name="name" v-model="users.name" id="name"
                                placeholder="Nome do usuário">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="registry"><span class="required">*</span> Matrícula do Usuário</label>
                            <input type="text" class="form-control" name="registry" v-model="users.registry" id="registry"
                                placeholder="xxxxxxxx">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="email"><span class="required">*</span> E-mail do Usuário</label>
                            <input type="email" class="form-control" name="email" v-model="users.email" id="email" readonly
                                placeholder="nome@empresa.com.br">
                        </div>
                    </div>
                    
                    <div class="row">
                        
                        <div class="form-group col-md-6">
                            <label for="password"><span class="required">*</span> Senha</label>
                            <input type="password" name="password" class="form-control" id="password" readonly
                                placeholder="***********" v-model="users.password">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="password"><span class="required">*</span>Confirmar Senha</label>
                            <input type="password" name="confirmed_password" class="form-control" id="confirmed_password"
                                readonly placeholder="***********" v-model="users.confirmed_password">
                        </div>
                    </div>
                   
                </div>

                <div class="ibox-footer">
                    <div class="pull-right">
                        <router-link to="/users" class="btn btn-info">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                    <p><span class="required">*</span> Campos Obrigatórios</p>
                    <div class="clearfix"></div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert';

export default {
    data() {
        return {
            users: {
                name: '',
                email: '',
                password: '',
                confirmed_password: '',
                registry: '',
                // photo: '',
                // shift_id: '',
                // role_id: '',
                userType: '',
                // user_branches: '',
            },
          
            errors: undefined
        }
    },
    computed: {},
    methods: {
        checkConfirmation() {

            if (this.users.password == this.users.confirmed_password) {
                return true;
            } else {
                swal("Ops! Senhas não coincidem. Tente novamente.");
                return false;
            }

        },
        save: function () {
            const api = this.$store.state.api + 'domains/' + this.$route.params.id + '/users';
            const self = this;

            let form = new FormData();
            let photo = document.getElementById('photo');

            form.append('name', self.users.name);
            form.append('email', self.users.email);
            form.append('registry', self.users.registry);
            form.append('password', self.users.password);
            form.append('photo', null);
            // form.append('shift_id', null);
            // form.append('team_id', null);
            // form.append('role_id', null);
            // form.append('user_branches', null);
            form.append('userType', 'Administrador');

            if (this.checkConfirmation()) {
                self.$http.post(api, form)
                    .then((response) => {
                        self.users = response.data.data;
                        self.tableData = self.users;

                        self.$message('Sucesso', `Usuário cadastrado com sucesso`, 'success');

                        self.users = {

                            name: '',
                            email: '',
                            password: '',
                            registry: '',
                            photo: '',
                            shift_id: '',
                            role_id: '',
                            team_id: '',
                            userType: '',
                            user_branches:'',
                        };
                        self.$router.push('/domains/view/' + self.$route.params.id);

                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if (typeof self.errors === 'object') {
                            let html = '<ul>';

                            $.each(self.errors, function (key, value) {
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });

            }

        },
                
        loadMessage() {
            let senha = document.getElementById("password");
            let email = document.getElementById("email");
            let confirmaSenha = document.getElementById("confirmed_password");

            senha.removeAttribute("readonly");
            email.removeAttribute("readonly");
            confirmaSenha.removeAttribute("readonly");
        },
    },
    mounted: function () {
        setTimeout(() => {
            this.loadMessage();
        }, 300);


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label::after {
    content: ":";
    margin-right: 5px; 
}
</style>



// WEBPACK FOOTER //
// src/components/Domains/Users/Add.vue